import InfoField from '../InfoField';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy, faLink } from '@fortawesome/free-solid-svg-icons';

const isOpenableUrl = (url) =>
    typeof url === 'string' && /^https?:\/\//i.test(url.trim());

const iconStyle = { color: '#215732', cursor: 'pointer' };

const PiezaUrlActions = ({ display, onCopyPiezaUrl }) => (
    <>
        {display && onCopyPiezaUrl ? (
            <FontAwesomeIcon
                icon={faCopy}
                onClick={() => onCopyPiezaUrl(display)}
                style={iconStyle}
            />
        ) : null}
        {isOpenableUrl(display) ? (
            <FontAwesomeIcon
                icon={faLink}
                onClick={() =>
                    window.open(display.trim(), '_blank', 'noopener,noreferrer')
                }
                style={iconStyle}
            />
        ) : null}
    </>
);

const PiezaUrlInfoField = ({
    piezaUrl,
    onCopyPiezaUrl,
    label = 'Url',
    className = 'd-flex gap-2 flex-wrap align-items-start',
    compact = false,
}) => {
    const display = piezaUrl ?? null;

    if (compact) {
        if (!display) return null;

        return (
            <span className="d-flex flex-wrap align-items-center gap-2 mt-1">
                <span>
                    URL:{' '}
                    <b style={{ wordBreak: 'break-all', fontWeight: 600 }}>
                        {display}
                    </b>
                </span>
                <PiezaUrlActions
                    display={display}
                    onCopyPiezaUrl={onCopyPiezaUrl}
                />
            </span>
        );
    }

    return (
        <InfoField
            label={label}
            className={className}
            value={
                <>
                    <span
                        style={{
                            maxWidth: '740px',
                            wordBreak: 'break-all',
                        }}
                    >
                        {display ?? '-'}
                    </span>
                    <PiezaUrlActions
                        display={display}
                        onCopyPiezaUrl={onCopyPiezaUrl}
                    />
                </>
            }
        />
    );
};

export default PiezaUrlInfoField;
